import delegate from "delegate-it";
import gsap from "gsap";
import SplitType from "split-type";
import { fireEvent } from "@/scripts/common/util";

const initializeSiteMenu = (siteMenuTrigger) => {
    const openLabel = siteMenuTrigger.querySelector(".btn-label");
    const closeLabel = siteMenuTrigger.querySelector(".btn-label-close");

    const siteMenu = document.getElementById("site-menu");

    const splitOpenText = new SplitType(openLabel, {
        types: "chars",
        lineClass: "split-open",
    });

    const splitCloseText = new SplitType(closeLabel, {
        types: "chars",
        lineClass: "split-close",
    });

    gsap.set(splitCloseText.chars, { y: "150%" });

    const openMenu = () => {
        siteMenuTrigger.setAttribute("aria-expanded", "true");

        gsap.to(splitOpenText.chars, {
            duration: 0.3,
            y: "-150%",
            ease: "power3.out",
            stagger: 0.05,
        });

        gsap.to(splitCloseText.chars, {
            duration: 0.3,
            y: "0%",
            ease: "power3.out",
            stagger: 0.05,
        });

        gsap.timeline({
            onComplete: () => {
                requestAnimationFrame(() => {
                    siteMenu.classList.add("is-open");
                });
            },
        })
            .fromTo(
                siteMenu.querySelectorAll(".menu-primary > li"),
                { opacity: 0, yPercent: 20 },
                { opacity: 1, yPercent: 0, stagger: 0.3, ease: "ease" },
            )
            .duration(0.8);
    };

    const closeMenu = () => {
        siteMenuTrigger.setAttribute("aria-expanded", "false");

        gsap.to(splitOpenText.chars, {
            duration: 0.3,
            y: "0%",
            ease: "power3.out",
            stagger: 0.05,
        });

        gsap.to(splitCloseText.chars, {
            duration: 0.3,
            y: "150%",
            ease: "power3.out",
            stagger: 0.05,
        });

        gsap.timeline({
            onComplete: () => {
                requestAnimationFrame(() => {
                    siteMenu.classList.remove("is-open");
                });
            },
        })
            .to(
                siteMenu.querySelectorAll(".menu-primary > li"),
                { opacity: 0, yPercent: -20, stagger: 0.5, ease: "ease" },
                "<",
            )
            .duration(0.5);

        fireEvent("slidetoggle:reset", siteMenu.querySelectorAll('[data-slide-toggle][aria-expanded="true"]'));
    };

    delegate("html", "sitemenu:open", openMenu);
    delegate("html", "sitemenu:close", closeMenu);
};

export default {
    init: () => {
        const siteMenuTrigger = document.querySelector(".site-menu-trigger");

        if (siteMenuTrigger) {
            initializeSiteMenu(siteMenuTrigger);
        }
    },
};
